import Vue from "vue";
import Router from "vue-router";
import store from "./store";

//import Home from "./views/Home.vue";

//events routes
import Events from "./views/events/Events.vue";
import Event from "./views/events/Event.vue";

//event logs routes
import EventLogs from "./views/EventLogs";

//auth routes
import Register from "./views/auth/Register.vue";
import Login from "./views/auth/Login.vue";
import Unauthorized from "./views/Unauthorized.vue";

//Users routes
import Users from "./views/Users.vue";
import Profile from "./views/Profile.vue";

//Print routes
import PrintJobs from "./views/PrintJobs.vue";

//Sectors routes
import Sectors from "./views/sectors/Sectors.vue";
import Sector from "./views/sectors/Sector.vue";

//Dashboard routes
import EventsDashboard from "./views/dashboards/Events.vue";
import EventDashboard from "./views/dashboards/Event.vue";
import SectorsDashboard from "./views/dashboards/SectorsDash.vue";

//Prepaid routes
import PrepaidGroups from "./views/prepaid/PrepaidGroups";
import PrepaidGroup from "./views/prepaid/PrepaidGroup";
import PrepaidCard from "./views/prepaid/PrepaidCard";

//Ticket scanning routes
import TicketScan from "./views/TicketScan";

//Billeting routes
import SalesUsers from "./views/sales/Users";
import SalesEvents from "./views/sales/Events";
import SalesUserEvent from "./views/sales/UserEvent";
import SalesmanEvents from "./views/sales/SalesmanEvents";
import SalesmanEvent from "./views/sales/SalesmanEvent";
import SalesmanAssignment from "./views/sales/SalesmanAssignment";

Vue.use(Router);

const router = new Router({
  mode: "history",
  linkExactActiveClass: 'is-active',
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/users",
      name: "users",
      component: Users,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    },
    {
      path: "/auth/register",
      name: "register",
      component: Register,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    },
    {
      path: "/auth/login",
      name: "login",
      component: Login
    },
    {
      path: "/",
      redirect: "/events",
    },
    {
      path: "/events",
      name: "events",
      component: Events,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    },
    {
      path: "/events/:id",
      name: "event",
      component: Event,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    },
    {
      path: "/eventLogs",
      name: "eventLogs",
      component: EventLogs,
      meta: {
        requiresAuth: true,
        requiresSecurity: true,
      }
    },
    {
      path: "/profile",
      name: "profile",
      component: Profile,
      meta: {
        requiresAuth: true,
        requiresSecurity: true,
      }
    },
    {
      path: "/print_jobs",
      name: "printJobs",
      component: PrintJobs,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    },
    {
      path: "/sectors",
      name: "sectors",
      component: Sectors,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    },
    {
      path: "/sectors/:id",
      name: "Sector",
      component: Sector,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: EventsDashboard,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    },
    {
      path: "/dashboard/:id",
      name: "eventDashboard",
      component: EventDashboard,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    },
    {
      path: "/dashboard/sectors",
      name: "sectorsDashboard",
      component: SectorsDashboard,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    },
    {
      path: "/prepaid/",
      name: "prepaidGroups",
      component: PrepaidGroups,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    },
    {
      path: "/prepaid/:id",
      name: "prepaidGroup",
      component: PrepaidGroup,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    },
    {
      path: "/prepaid/card/:id",
      name: "prepaidCard",
      component: PrepaidCard,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    },
    {
      path: "/ticket_scan",
      name: "ticketScan",
      component: TicketScan,
      meta: {
        requiresAuth: true,
        requiresSecurity: true
      }
    },
    {
      path: "/sales/:event_id/users",
      name: "salesUsers",
      component: SalesUsers,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    },
    {
      path: "/sales/events",
      name: "salesUser",
      component: SalesEvents,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    },
    {
      path: "/sales/:event_id/:id/",
      name: "salesUserEvent",
      component: SalesUserEvent,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    },
    {
      path: "/salesman/",
      name: "salesmanEvents",
      component: SalesmanEvents,
      meta: {
        requiresAuth: true,
        requiresSales: true
      }
    },
    {
      path: "/salesman/:event_id",
      name: "salesmanEvent",
      component: SalesmanEvent,
      meta: {
        requiresAuth: true,
        requiresSales: true
      }
    },
    {
      path: "/salesman/:event_id/:assignment_id",
      name: "salesmanAssignment",
      component: SalesmanAssignment,
      meta: {
        requiresAuth: true,
        requiresSales: true
      }
    },
    {
      path: "/403",
      name: "unauthorized",
      component: Unauthorized,
      meta: {
        requiresAuth: true
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  let user = store.getters.currentUser;
  if (to.meta.requiresAuth) {
    if (!user) {
      next("/auth/login");
    } else if (to.meta.requiresAdmin) {
      if (user.role === "administrator") {
        next();
      } else {
        next("/ticket_scan");
      }
    } else if (to.meta.requiresSales) {
      if (user.role === "sales" || user.role === "administrator") {
        next();
      } else {
        next("/ticket_scan");
      }
    } else if (to.meta.requiresSecurity) {
      if (
        user.role === "guest" ||
        user.role === "administrator" ||
        user.role === "sales"
      ) {
        next();
      } else {
        ("/auth/login");
      }
    }
  } else {
    next();
  }
});

export default router;
